import { ConversationFiltersButton } from "../ConversationFilters/styles";
import useMoveConversationToSpam from "./use-move-conversation-to-spam";
import { Tooltip } from "react-tooltip";

const SpamButton = () => {
	const moveConversationToSpam = useMoveConversationToSpam();
	return (
		<>
			<ConversationFiltersButton
				data-tooltip-id="spam-tooltip"
				data-tooltip-content="Move to Spam"
				style={{ float: "right" }}
				icon="fas fa-exclamation-circle"
				onClick={moveConversationToSpam}
			/>
			<Tooltip id="spam-tooltip" place="top" />
		</>
	);
};

export default SpamButton;
